import { Container, Graphics, Text } from 'pixi.js';
import last from 'lodash/last';
import { SolverVisualisationStepView } from './SolverVisualisationStepView';
import type { Solver } from './Solver';
import type { SolverHistoryStep } from './types';

export class SolverLiveView extends Container {
  private stepView: SolverVisualisationStepView | null = null;

  constructor(private readonly solver: Solver) {
    super();
    this.init();
  }

  private init(): void {
    this.addBackground();
    this.createNavigationBar();
  }

  private addBackground(): void {
    const gfx = new Graphics();
    gfx.rect(0, 0, 4000, 4000);
    gfx.fill(0x878787);
    gfx.eventMode = 'static';
    gfx.props({ parent: this });
  }

  private setStep(step: SolverHistoryStep): void {
    this.stepView?.destroy({ children: true });
    this.stepView = new SolverVisualisationStepView(step).props({
      parent: this,
    });
  }

  private createNavigationBar(): void {
    const navigationContainer = new Container().props({
      parent: this,
      x: 100,
      y: 1200,
    });

    this.addButton('NEXT', () => {
      this.solver.makeMove();
      const step = last(this.solver.getHistory().steps);
      if (!step) {
        console.warn('no step');
        return;
      }
      this.setStep(step);
    }).props({
      parent: navigationContainer,
    });

    this.addButton('PERF', () => {
      this.stepView?.animateMove();
    }).props({
      parent: navigationContainer,
      x: 500,
    });

    this.addButton('CLOSE', () => {
      this.destroy({ children: true });
    }).props({
      parent: navigationContainer,
      x: 1000,
    });
  }

  private addButton(label: string, callback: () => void): Text {
    const button = new Text(label, {
      fontSize: 40,
      fill: 'black',
    });
    button.eventMode = 'static';
    button.on('pointertap', callback);
    return button;
  }
}
